import { h } from "preact";
import { useContext } from "preact/hooks";
import { KeycloakContext } from "../../providers/KeycloakContext";


export default function AuthControl({ children }) {

    const { isAuthenticated, keycloakClient } = useContext(KeycloakContext);

    if (!keycloakClient) {
        return <div>Loading...</div>;
    }

    if (isAuthenticated) {
        return children;
    } else {
        return keycloakClient.login();
    }
}